module.exports = __webpack_public_path__ + "img/sale-rank2.d0f78b0c.png";